import React from 'react';
export function EducationSection() {
  const blocks = ['Um jantar mais salgado pode causar retenção no dia seguinte.', 'Um pão à noite pode deixar a barriga mais estufada.', 'Um fim de semana fora da rotina pode aumentar rapidamente a sensação de peso.', 'Dietas agressivas podem gerar mais fome, cansaço e desistência.'];
  return <section className="py-16 md:py-24 bg-white" data-id="element-22">
      <div className="max-w-5xl mx-auto px-5 md:px-8" data-id="element-23">
        <div className="text-center mb-12" data-id="element-24">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-dark mb-6" data-id="element-25">
            O Que Está Acontecendo Com Seu Corpo?
          </h2>
          <p className="text-lg text-brand-text/80 leading-relaxed max-w-3xl mx-auto" data-id="element-26">
            Depois dos 40, é comum o corpo reagir de forma diferente aos mesmos
            alimentos, horários e hábitos. Coisas que antes não incomodavam
            agora podem causar peso, estufamento e retenção.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 mb-12" data-id="element-27">
          {blocks.map((block, index) => <div key={index} className="bg-brand-cream p-6 rounded-2xl border border-brand-sage/30 shadow-sm flex items-center justify-center text-center" data-id="element-28">
              <p className="text-brand-text font-medium text-lg" data-id="element-29">{block}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-30">
          <p className="inline-block bg-brand-sage/20 px-6 py-4 rounded-xl text-xl md:text-2xl font-serif font-medium text-brand-dark border border-brand-sage/50" data-id="element-31">
            Por isso, o Desincha40+ trabalha com uma lógica diferente: primeiro
            desinchar, depois reequilibrar, depois manter.
          </p>
        </div>
      </div>
    </section>;
}